// extracted by mini-css-extract-plugin
export default {"container":"Grid_container__+YdLA"};